import { Check, X } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { SITE_NAME } from "../translations";

const FEATURES = [
  { en: "No account required", fr: "Sans compte requis" },
  { en: "100% Free — no hidden fees", fr: "100% Gratuit — sans frais cachés" },
  { en: "French & English interface", fr: "Interface Français & Anglais" },
  { en: "Files never stored on servers", fr: "Fichiers jamais stockés sur serveur" },
  { en: "Smart PDF Analyzer", fr: "Analyseur PDF intelligent" },
  { en: "Roadmap: Excel, Word & image tools", fr: "Roadmap : outils Excel, Word & image" },
];

const COMPETITORS = [
  { name: SITE_NAME, highlight: true, values: [true, true, true, true, true, true] },
  { name: "SmallPDF", highlight: false, values: [false, false, true, false, false, false] },
  { name: "iLovePDF", highlight: false, values: [false, false, false, false, false, false] },
];

export default function ComparisonSection() {
  const { lang } = useLanguage();

  const title = lang === "fr" ? `${SITE_NAME} vs la concurrence` : `${SITE_NAME} vs competitors`;
  const subtitle = lang === "fr"
    ? `Pourquoi choisir ${SITE_NAME} ?`
    : `Why choose ${SITE_NAME}?`;

  return (
    <section className="py-14 bg-white border-t border-slate-100" data-testid="comparison-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
            {title}
          </h2>
          <p className="text-slate-500 text-sm">{subtitle}</p>
        </div>

        <div className="overflow-x-auto rounded-2xl border border-slate-200 shadow-sm">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-200">
                <th className="text-left px-5 py-4 font-semibold text-slate-700 w-1/2">
                  {lang === "fr" ? "Fonctionnalité" : "Feature"}
                </th>
                {COMPETITORS.map((c) => (
                  <th
                    key={c.name}
                    className={`px-4 py-4 text-center font-semibold text-sm ${c.highlight ? "text-blue-600 bg-blue-50" : "text-slate-500"}`}
                    style={{ fontFamily: "'Outfit', sans-serif" }}
                  >
                    {c.name}
                    {c.highlight && (
                      <span className="ml-1 text-xs bg-blue-600 text-white px-1.5 py-0.5 rounded-full">✓</span>
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {FEATURES.map((f, fi) => (
                <tr key={fi} className={`border-b border-slate-100 last:border-0 ${fi % 2 === 0 ? "bg-white" : "bg-slate-50/40"}`}>
                  <td className="px-5 py-3.5 text-slate-700 font-medium">
                    {lang === "fr" ? f.fr : f.en}
                  </td>
                  {COMPETITORS.map((c) => (
                    <td key={c.name} className={`px-4 py-3.5 text-center ${c.highlight ? "bg-blue-50/40" : ""}`}>
                      {c.values[fi] ? (
                        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-green-100">
                          <Check className="w-3.5 h-3.5 text-green-600" />
                        </span>
                      ) : (
                        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-red-50">
                          <X className="w-3.5 h-3.5 text-red-400" />
                        </span>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
